import { render, staticRenderFns } from "./PlaceUpdate.vue?vue&type=template&id=f466c9de&"
import script from "./PlaceUpdate.vue?vue&type=script&lang=js&"
export * from "./PlaceUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports